enum ENTRY_ID_TYPE {
  header = 'blt726964bea7216aa8',
  footer = 'bltde73a205ac23f654',
  brandsMenu = '',
  infoUserRoles = 'blt1827ce41e79f7f8d',
  logoSlider = 'blt7d31b5b2cdd4b621',
}

export { ENTRY_ID_TYPE };
export * from 'b2b-apps/core/content/hooks/useEntry';
